/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseCampaignStateDto } from '../../models/recourse-campaign-state-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetRecourseCampaignStates$Params {}

export function getRecourseCampaignStates(
  http: HttpClient,
  rootUrl: string,
  params?: GetRecourseCampaignStates$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<RecourseCampaignStateDto>>> {
  const rb = new RequestBuilder(rootUrl, getRecourseCampaignStates.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RecourseCampaignStateDto>>;
    }),
  );
}

getRecourseCampaignStates.PATH = '/service/v1/recourseCampaignState';
